import React from 'react';
import { View, Animated, TouchableWithoutFeedback } from 'react-native';

import { ViewPropTypes, TextPropTypes } from 'deprecated-react-native-prop-types';
import _ from 'lodash';
import PropTypes from 'prop-types';

import { Icon, VFText, IconTypes } from '@vfgroup-oneplatform/foundation/Components';
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PRODUCT_STATUS } from '../../../Services/Enums';
import { Images } from '../../../Themes';

import styles from './DashboardPlansInfoCard.Styles';

function DashboardPlansInfoCard({
  id,
  icon,
  iconType,
  iconSize,
  title,
  name,
  description,
  descriptionPlaceholders,
  status,
  style,
  titleContainerStyle,
  titleStyle,
  infoContainerStyle,
  nameStyle,
  descriptionStyle,
  statusStyle,
  iconAccessibilityLabel,
  titleAccessibilityLabel,
  statusAccessibilityLabel,
  onPress,
  ...props
}) {
  const theme = useTheme();

  return (
    <TouchableWithoutFeedback onPress={() => _.isFunction(onPress) && onPress(id)}>
      <Animated.View style={[styles.containerStyle(theme), style]}>
        <Animated.View style={[styles.titleContainerStyle, titleContainerStyle]}>
          <Icon
            type={iconType}
            name={icon}
            size={iconSize}
            accessibilityLabel={iconAccessibilityLabel}
          />
          <VFText
            i18nKey={title}
            style={[styles.titleTextStyle(theme), titleStyle]}
            accessibilityLabel={titleAccessibilityLabel}
          />
        </Animated.View>
        <View style={infoContainerStyle}>
          <VFText
            numberOfLines={1}
            i18nKey={name}
            style={[styles.nameTextStyle(theme), nameStyle]}
          />
          <VFText
            i18nKey={description}
            placeHolders={descriptionPlaceholders}
            style={[styles.descriptionTextStyle(theme), descriptionStyle]}
          />
        </View>

        <View style={styles.footerContainer}>
          <View style={styles.statusDotStyle(status)} />
          <VFText
            i18nKey={
              status === PRODUCT_STATUS.ACTIVE
                ? 'soho_main_tile_my_plan_active_status'
                : 'soho_main_tile_my_plan_in_active_status'
            }
            style={[styles.statusStyle(theme), statusStyle]}
            accessibilityLabel={statusAccessibilityLabel}
          />
        </View>
      </Animated.View>
    </TouchableWithoutFeedback>
  );
}

DashboardPlansInfoCard.defaultProps = {
  iconType: IconTypes.image,
  iconSize: 25,
  title: 'soho_my_plan_tile_title',
  icon: Images.ic_enterprise,
};

DashboardPlansInfoCard.propTypes = {
  id: PropTypes.string.isRequired,
  icon: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      uri: PropTypes.string.isRequired,
    }),
  ]),
  iconType: PropTypes.oneOf(Object.values(IconTypes)).isRequired,
  iconSize: PropTypes.number,
  title: PropTypes.string,
  name: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  descriptionPlaceholders: PropTypes.arrayOf(PropTypes.any),
  style: ViewPropTypes.style,
  titleContainerStyle: PropTypes.object,
  titleStyle: TextPropTypes.style,
  nameStyle: TextPropTypes.style,
  descriptionStyle: TextPropTypes.style,
  infoContainerStyle: ViewPropTypes.style,
  statusStyle: TextPropTypes.style,
  iconAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  titleAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  statusAccessibilityLabel: ViewPropTypes.accessibilityLabel,
  status: PropTypes.string.isRequired,
  onPress: PropTypes.func,
};

export default DashboardPlansInfoCard;
